import PropTypes from "prop-types";
import { Card, CardContent } from "../ui/card";

function NewsCard({ image, title, source, link = "#" }) {
  return (
    <a
      onClick={() =>
        window.open(
          link,
          "_blank",
        )
      }
      className="block hover:opacity-95 transition-opacity"
    >
      <Card className="overflow-hidden border-0 shadow-md w-[300px] flex-shrink-0">
        <div className="relative w-full h-[160px]">
          <img
            src={image || "/placeholder.svg"}
            alt={title}
            className="object-cover rounded-t-lg w-full h-full"
          />
        </div>
        <CardContent className="p-4">
          <h3 className="text-lg font-semibold line-clamp-2 mb-2">{title}</h3>
          <p className="text-gray-400 text-sm">{source}</p>
        </CardContent>
      </Card>
    </a>
  );
}

NewsCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  link: PropTypes.string
};

export default NewsCard;
